import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Mraz",
  "description": "",
  "published": "2006-12-14T00:00:00.000Z",
  "redirect_from": ["/blog/mraz/swizec/345"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Zunaj se je shladilo, povprecna temperatura prejsnjega tedna je bila okoli 15°C, ta teden pa gravitira bolj na 0°C ... hvala ti globalno segrevanje, ljubimo te, res. Ampak, resno, mraz je super, veliko boljsi je kot vrocina. Tezko bi se odlocil zakaj, mogoce zaradi vse zabave, ki jo izluscim iz dejstva, da sem normalno oblecen, mogoce pa je preprosto zato, ker se ne pripeti na vsakem koraku, da bi razgaljene prsi hotele iztakniti moje oci. Hud mraz je pa seveda zelo slab, ponavadi tudi bolec, ampak hudega mraza tu tako skoraj nikoli ni.`}</p>
    <p>{`Je pa z mrazom povezanih nekaj unikatnih problemov, ki jih v toplem vremenu ni. Tako imamo na primer vedno prisotno nizko sonce, ki se trudi ubiti oci vseh, ki ga gledajo, je pac nevzgojeno in neotesano. Drugi pa je, da moj najljubsi prostor za pridobivanje caja nikoli nima casa zame, vedno je polno zaseden, se sploh kadar jaz potrebujem caj. Caj je odlicen, lepo se usedes in lahko v miru ustvarjas, ampak to je zelo otezeno ce ne mores do caja ...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      